import React from 'react';
import Avatar from '../../avatar/Avatar';

const UserProfileAvatar = ({ profileImgUrl, name, jobFunc }) => {
  return (
    <>
      <Avatar src={profileImgUrl} />
      <div className='text-center'>
        <h6 className='mt-3 mb-1'>{name}</h6>
        <p>{jobFunc}</p>
      </div>
    </>
  )
}

export default UserProfileAvatar;